require('./angular');
module.exports = angular;



//////////////////
// WEBPACK FOOTER
// ./~/angular-oauth2/~/angular/index.js
// module id = 49
// module chunks = 1